import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

export function tightSpreadPctBuilder({parsedStatusObj}) {
  const { pct } = parsedStatusObj;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Tight spread filter failed. Max spread:
        {pct ? ApplyRounding(Number(pct), 2) * 100 + '%' : 'unknown'}.
      </Body3>
    </td>
  );
}
